import { useNavigate } from 'react-router-dom';
import "../styles/Orders.css"


function OrderItemCard({ item }) {
    const navigate = useNavigate();
    const cartItemHandler = (e) => {
        navigate(`/books/${item.book._id}`)
    }
    return (
        <div className='orderItemCard' onClick={cartItemHandler} >
            {/* <div>
                <h5 style={{ color: "#888" }}>{item.book.author}</h5>
                <h3 style={{ color: "var(--primary-color)" }}>{item.book.title}</h3>
                <p style={{ color: "#333" }}>Quantity: {item.quantity}</p>
            </div> */}
            <img src={item?.coverImage} alt={item.book.title} height={120} width={120} />
        </div>
    )
}

export default OrderItemCard